<script lang="ts" setup>
  import Button from '@leaflink/stash/Button.vue';
  import Icon from '@leaflink/stash/Icon.vue';
  import { computed, onMounted, ref } from 'vue';

  import { AUTHORIZE_NET_URL } from '@/constants';
  import { env } from '@/constants/env';
  import api from '@/services/api';

  const authNetDomain = computed(() => (env.MODE === 'production' ? 'accept' : 'test'));
  const redirectToken = ref('');
  const emit = defineEmits<{
    (e: 'submit'): void;
    (e: 'click'): void;
  }>();

  onMounted(async () => {
    const acceptCustomer = await api.settings.getAcceptCustomerToken();

    redirectToken.value = acceptCustomer.token;
  });
</script>

<template>
  <form
    class="tw-flex tw-flex-col tw-gap-y-3"
    method="post"
    :action="`https://${authNetDomain}.${AUTHORIZE_NET_URL.EDIT_PAYMENT}`"
    :title="$t('settings.billing.editPaymentMethodsModal.addPaymentMethods.addCreditCardLabel')"
    id="acceptCustomerForm"
    name="acceptCustomerForm"
    target="_blank"
    @submit="emit('submit')"
  >
    <input type="hidden" id="redirectToken" name="token" :value="redirectToken" />

    <Button secondary color="blue" :disabled="!redirectToken" @click="emit('click')">
      <span class="tw-flex tw-gap-2 tw-items-center tw-justify-center">
        <Icon name="credit-card" />
        {{ $t('settings.billing.editPaymentMethodsModal.addPaymentMethods.addCreditCardLabel') }}
      </span>
    </Button>
  </form>
</template>
